export default "__VITE_ASSET__D77jgahZ__"